/**
 * Analytics Portal V1 — a titled group of KPI cards (Phase 10).
 *
 * A metric appears only if the API returned it and the current scope can produce it. The card
 * itself decides value vs. notice, so this component never inspects `available` or a number.
 */
import React from "react";
import { KpiCard } from "./KpiCard";

export const KpiGroup = ({ id, title, description, metrics = [], kpis = {}, scopeTypes = [],
                           rangeSuggestion, onUseSupportedRange }) => {
  const visible = metrics.filter((entry) => kpis[entry.key]
    && (!entry.types || entry.types.some((type) => scopeTypes.includes(type))));
  if (!visible.length) return null;

  return (
    <section className="space-y-3" data-testid={`analytics-summary-${id}`}
             aria-labelledby={`analytics-summary-${id}-heading`}>
      <div>
        <h2 id={`analytics-summary-${id}-heading`}
            className="text-base font-[620] text-foreground md:text-lg">{title}</h2>
        {description && <p className="mt-0.5 text-sm text-muted-foreground">{description}</p>}
      </div>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
        {visible.map((entry) => (
          <KpiCard key={entry.key} metricKey={entry.key} label={entry.label} hint={entry.hint}
                   suffix={entry.suffix || ""}
                   metric={kpis[entry.key]} rangeSuggestion={rangeSuggestion}
                   onUseSupportedRange={onUseSupportedRange} />
        ))}
      </div>
    </section>
  );
};
